import { cva, VariantProps } from "class-variance-authority";
import { HiXMark } from "react-icons/hi2";

import Button from "@/components/atoms/Button";

const modalSizes = cva("sticky flex justify-end", {
  variants: {
    padding: {
      none: "top-0",
      sm: "top-6",
      md: "top-8",
      lg: "top-10",
    },
  },
  defaultVariants: {
    padding: "sm",
  },
});

type Props = VariantProps<typeof modalSizes> & {
  children?: React.ReactNode;
  preventClose?: boolean;
  onClose: (value: boolean) => void;
};

const EmptyModalContent = ({ children, preventClose = false, onClose, padding, ...props }: Props) => {
  return (
    <div {...props}>
      {!preventClose && (
        <div className={modalSizes({ padding })}>
          <Button
            onClick={() => onClose(false)}
            className={"!p-1"}
            leadingIcon={<HiXMark className={"size-6 shrink-0 text-fg-quinary"} />}
            color={"natural"}
            variants={"text"}
            size={"xs"}
          />
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};

export default EmptyModalContent;
